/**
 * OnboardingStep2.tsx - Career Paths
 * Second step of the onboarding flow.
 * Allows users to select career paths they're interested in (multi-select).
 * Uses ChipSelector component with career options.
 */
import React from "react";
import { View } from "react-native";
import OnboardingStepHeader from "./common/OnboardingStepHeader";
import ChipSelector, { ChipOption } from "../../common/form/ChipSelect/ChipSelector";
import CustomText from "../../common/general/CustomText/CustomText";
import { spacingStyles } from "../../../styles/design-system";

export interface OnboardingStep2Props {
  selectedCareerPaths: string[];
  onCareerPathsChange: (paths: string[]) => void;
}

const careerOptions: ChipOption[] = [
  { key: "software_engineering", value: "Software Engineering", icon: <CustomText text="🧑‍💻" size="m" useTranslationText={false} style={undefined} /> },
  { key: "medicine", value: "Medicine", icon: <CustomText text="🩺" size="m" useTranslationText={false} style={undefined} /> },
  { key: "finance", value: "Finance", icon: <CustomText text="📈" size="m" useTranslationText={false} style={undefined} /> },
  { key: "research", value: "Research", icon: <CustomText text="🧪" size="m" useTranslationText={false} style={undefined} /> },
  { key: "teaching", value: "Teaching", icon: <CustomText text="🧑‍🏫" size="m" useTranslationText={false} style={undefined} /> },
  { key: "design", value: "Design", icon: <CustomText text="🎨" size="m" useTranslationText={false} style={undefined} /> },
  { key: "ai_data_science", value: "AI & Data Science", icon: <CustomText text="🤖" size="m" useTranslationText={false} style={undefined} /> },
  { key: "law", value: "Law", icon: <CustomText text="⚖️" size="m" useTranslationText={false} style={undefined} /> },
  { key: "engineering", value: "Engineering", icon: <CustomText text="🛠️" size="m" useTranslationText={false} style={undefined} /> },
  { key: "marketing", value: "Marketing", icon: <CustomText text="📣" size="m" useTranslationText={false} style={undefined} /> },
  { key: "arts_media", value: "Arts & Media", icon: <CustomText text="🎬" size="m" useTranslationText={false} style={undefined} /> },
  { key: "public_service", value: "Public Service", icon: <CustomText text="🤝" size="m" useTranslationText={false} style={undefined} /> },
];

function OnboardingStep2({ selectedCareerPaths, onCareerPathsChange }: OnboardingStep2Props) {
  return (
    <View style={[spacingStyles.mNone]}>
      <OnboardingStepHeader
        titleKey="companion_onboarding_step2_title"
        subtitleKey="companion_onboarding_step2_subtitle"
      />
      <ChipSelector
        options={careerOptions}
        selectedKeys={selectedCareerPaths}
        onSelectionChange={onCareerPathsChange}
        multiSelect
      />
    </View>
  );
}


export default OnboardingStep2;
